import React, { useEffect } from "react";

const Spinner = () => {
    const styles = {
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1000, // Ensure it's on top of other content
        },
        spinnerContainer: {
          width: "44px",
          height: "44px",
          position: "relative",
          animation: "spinner-animation 2s infinite ease",
          transformStyle: "preserve-3d",
        },
        face: {
          backgroundColor: "rgba(0, 77, 255, 0.2)",
          height: "100%",
          width: "100%",
          position: "absolute",
          border: "2px solid #004dff",
        },
        faceTransforms: [
          { transform: "translateZ(-22px) rotateY(180deg)" },
          { transform: "rotateY(-270deg) translateX(50%)", transformOrigin: "top right" },
          { transform: "rotateY(270deg) translateX(-50%)", transformOrigin: "center left" },
          { transform: "rotateX(90deg) translateY(-50%)", transformOrigin: "top center" },
          { transform: "rotateX(-90deg) translateY(50%)", transformOrigin: "bottom center" },
          { transform: "translateZ(22px)" },
        ],
        keyframes: `
          @keyframes spinner-animation {
            0% {
              transform: rotate(45deg) rotateX(-25deg) rotateY(25deg);
            }
            50% {
              transform: rotate(45deg) rotateX(-385deg) rotateY(25deg);
            }
            100% {
              transform: rotate(45deg) rotateX(-385deg) rotateY(385deg);
            }
          }
        `,
      };
    
      // Inject keyframes into the document
      React.useEffect(() => {
        const styleSheetId = "spinner-animation-keyframes";
        if (!document.getElementById(styleSheetId)) {
          const styleElement = document.createElement("style");
          styleElement.id = styleSheetId;
          styleElement.innerHTML = styles.keyframes;
          document.head.appendChild(styleElement);
        }
      }, []);
    
      return (
        <div style={styles.overlay}>
          <div style={styles.spinnerContainer}>
            {styles.faceTransforms.map((transformStyle, index) => (
              <div key={index} style={{ ...styles.face, ...transformStyle }} />
            ))}
          </div>
        </div>
      );
};

export default Spinner;
